import React, { type ReactNode } from 'react';

import { NftCardHeroInteriorAlignment } from '../../types';

import { StyledFooter, StyledHeader, StyledHero, StyledInterior, StyledMain } from './styles';

export interface HeroCommonProps {
    children?: ReactNode;
}

export interface HeroInteriorProps {
    alignment?: NftCardHeroInteriorAlignment;
    children?: ReactNode;
}

export function Hero({ children }: HeroCommonProps) {
    return <StyledHero>{children}</StyledHero>;
}

export function Header({ children }: HeroCommonProps) {
    return <StyledHeader>{children}</StyledHeader>;
}

export function Footer({ children }: HeroCommonProps) {
    return <StyledFooter>{children}</StyledFooter>;
}

export function Main({ children }: HeroCommonProps) {
    return <StyledMain>{children}</StyledMain>;
}

export function Interior({ alignment = NftCardHeroInteriorAlignment.Left, children }: HeroInteriorProps) {
    return <StyledInterior $alignment={alignment}>{children}</StyledInterior>;
}

Header.Interior = Interior;
Footer.Interior = Interior;

Hero.Header = Header;
Hero.Footer = Footer;
Hero.Main = Main;
